import { render, staticRenderFns } from "./columnWidth-editor.vue?vue&type=template&id=5f410a01&scoped=true&"
import script from "./columnWidth-editor.vue?vue&type=script&lang=js&"
export * from "./columnWidth-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f410a01",
  null
  
)

export default component.exports